// redux/slices/adminModeSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    adminMode: false, // Флаг для режима администратора
};

const adminModeSlice = createSlice({
    name: 'adminMode',
    initialState,
    reducers: {
        toggleAdminMode: (state) => {
            state.adminMode = !state.adminMode;
        },
        setAdminMode: (state, action) => {
            state.adminMode = Boolean(action.payload);
        },
    },
});

export const { toggleAdminMode, setAdminMode } = adminModeSlice.actions;
export default adminModeSlice.reducer;
